import { render, staticRenderFns } from "./DeleteTaskDataPointPopup.vue?vue&type=template&id=3d248fe9&scoped=true&"
import script from "./DeleteTaskDataPointPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteTaskDataPointPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteTaskDataPointPopup.vue?vue&type=style&index=0&id=3d248fe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d248fe9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d248fe9')) {
      api.createRecord('3d248fe9', component.options)
    } else {
      api.reload('3d248fe9', component.options)
    }
    module.hot.accept("./DeleteTaskDataPointPopup.vue?vue&type=template&id=3d248fe9&scoped=true&", function () {
      api.rerender('3d248fe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/DeleteTaskDataPointPopup.vue"
export default component.exports